const SHOW_LEGACY_BRANCHES_QUERY_PARAM = "showLegacyBranches";
const SHOW_LEGACY_BRANCHES_SESSION_KEY = "showLegacyBranches";

/**
 * Applies the showLegacyBranches query parameter from the URL to session storage.
 */
const applyShowLegacyBranchesFromUrl = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  const value = new URLSearchParams(window.location.search).get(SHOW_LEGACY_BRANCHES_QUERY_PARAM);
  if (value === "true") {
    window.sessionStorage.setItem(SHOW_LEGACY_BRANCHES_SESSION_KEY, "true");
  } else if (value === "false") {
    window.sessionStorage.removeItem(SHOW_LEGACY_BRANCHES_SESSION_KEY);
  }
};

applyShowLegacyBranchesFromUrl();

/**
 * Checks if the showLegacyBranches query parameter is set to true.
 */
export const isShowLegacyBranchesEnabled = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  return window.sessionStorage.getItem(SHOW_LEGACY_BRANCHES_SESSION_KEY) === "true";
};

/**
 * Retrieves the restricted branch ID from environment variables or session storage.
 * If showLegacyBranches is enabled, returns undefined.
 * If the environment variable is not set, returns undefined.
 * Otherwise, returns the branch ID as a string.
 */
export const getRestrictedBranchId = (): string | undefined => {
  if (isShowLegacyBranchesEnabled()) {
    return undefined;
  }
  const envBranchId = import.meta.env.VITE_RESTRICT_TO_LLTS_BRANCH;
  return envBranchId !== undefined && envBranchId !== "" ? String(envBranchId) : undefined;
};
